<template>
    <div class="bargain-item">
      <div class="bargain-item-left">
        <div class="bargin-item-thumb">
            <el-avatar :size="80" :src="data.thumb" shape="square"></el-avatar>
        </div>
        <div class="bargain-item-left-info">
            <span class="bargain-item-left-info-title">{{ data.name }}</span>
            <span class="bargain-item-left-info-status">砍价状态:<el-tag 
              size="small"
              :type="status[data.status].tag">{{ status[data.status].txt }}</el-tag></span>
            <span class="bargain-item-left-info-price">历史价格:¥{{ data.goods_price }}</span>
            <span class="bargain-item-left-info-price-new">议价价格:¥{{ data.price }}</span>
            <span class="bargain-item-left-info-time">{{ data.update_time }}</span>
            <el-button type="primary" style="height: 20px;line-height: 6px;" size="mini" @click="OpenUserThread(data.user_id)">打开用户对话</el-button>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "BargainItem",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data(){
    return {
      status:{
        0:{
          tag:"primary",
          txt:"待审核"
        },
        1:{
          tag:"success",
          txt:"已同意"
        },
        2:{
          tag:"danger",
          txt:"已拒绝"
        },
        3:{
          tag:"warning",
          txt:"已还价"
        }
      }
    }
  },
  methods:{
    OpenUserThread(user_id){
      this.$event.$emit('open_private',user_id);
    }
  }
};
</script>



<style scoped>
.bargain-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:2px;
    padding-bottom: 4px;
    margin: 0px 3px;
    font-size: 12px;
    margin-bottom: 2px;
    border-bottom: 1px solid #e5e5e5;
}

.bargain-item-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .bargin-item-thumb{
      border-right: 1px solid #e5e5e5;
      padding-right: 5px;
    }
}
.bargain-item-left-info {
    display: flex;
    flex-direction: column;
    padding-left: 5px;
    padding-right: 5px;
    justify-content: space-between;
    .bargain-item-left-info-title {
        width: 124px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .bargain-item-left-info-price{
      color: gray;
      text-decoration: line-through;
    }
    .bargain-item-left-info-price-new{
      color: #f56c6c;
    }
}


</style>